import Vue from 'vue'
import { scroll } from 'counselor-mobile-ui/directives'

// import { globalInterceptByPlatform } from 'counselor-mobile-ui/utils/feature/platform'
import {
  injectIconfontStyleSheet,
  injectMobileDebugTool,
} from 'counselor-mobile-ui/utils/feature/helper'
import router from './router'
import store from '@/public/store'
import App from '@/public/App.vue'

// 组件样式规范
// import 'counselor-mobile-ui/styles/global.less'

injectIconfontStyleSheet()
injectMobileDebugTool()

// 全局拦截
// globalInterceptByPlatform()
Vue.prototype.$EventBus = new Vue()

Vue.directive('scroll', scroll)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
